// extracted by mini-css-extract-plugin
export var videoHero = "_8v-4";
export var videoHeroImage = "_8v-5";
export var videoHeroOverlay = "_8v-6";
export var videoHeroSubtitle = "_8v-8";
export var videoHeroText = "_8v-7";
export var videoLauncher = "_8v-0";
export var videoLauncherIcon = "_8v-1";
export var videoLauncherSubtitle = "_8v-3";
export var videoLauncherTitle = "_8v-2";
export var videoPlayer = "_8v-a";
export var videoPlayerWrap = "_8v-9";